export const DL_KEYS = {
  viewMore: "VIEW MORE",
  callUs: "Call Us",
  Downloading: "Downloading",
  Download_receipt: "Download receipt",
  close: "Close",
  languages: "Languages",
  apply: "Apply",
  close_modal: "Close modal",
  send_Otp: "Send otp",
  continueAsAGuest: "Or continue as a guest",
  logOut: "Log out",
} as const;

export type DLKey = (typeof DL_KEYS)[keyof typeof DL_KEYS];
